/**
 * scroll-reveal.js — subtle fade-up reveals for [data-reveal] elements.
 *
 * The `reveal-ready` class on <html> is added synchronously in the document
 * head (see snippets/scroll-reveal.liquid), and only when motion is allowed
 * and IntersectionObserver is supported. That class is what gates the initial
 * hidden state in CSS, so content is never left invisible by a missing or
 * failed script:
 *   - prefers-reduced-motion / no-JS / no-IO → class absent → content shown
 *   - anything below throwing                → class removed → content shown
 *
 * Elements reveal once and are then unobserved; there is no re-hide on exit.
 */
const root = document.documentElement;

if (root.classList.contains('reveal-ready')) {
  try {
    const targets = document.querySelectorAll('[data-reveal]:not(.is-revealed)');

    const observer = new IntersectionObserver(
      (entries, obs) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        }
      },
      { threshold: 0, rootMargin: '0px 0px -12% 0px' }
    );

    for (const el of targets) observer.observe(el);
  } catch (error) {
    // Safety net: reveal everything rather than risk leaving content hidden.
    root.classList.remove('reveal-ready');
  }
}
